import React from 'react';
import classes from './Calendar.module.css';
import calendar from '../../../assets/img/calendar.png';

const Calendar = (props) => {
    return (
        <img src={calendar} alt="calendar" {...props} className={classes.calendar}/>
    )
}

export default Calendar;